import { serviceApi } from "./api-config"

export const getLocalidades = async () => {
    try{
        const { data } = await serviceApi.get(`api/procev/localidades`)
        return data
    }catch{
        throw new Error('Error al obtener las localidades ',id)
    }
}